import { render, staticRenderFns } from "./articimdet.vue?vue&type=template&id=7bc133b4&scoped=true&"
import script from "./articimdet.vue?vue&type=script&lang=js&"
export * from "./articimdet.vue?vue&type=script&lang=js&"
import style0 from "./articimdet.vue?vue&type=style&index=0&id=7bc133b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc133b4",
  null
  
)

export default component.exports